import React, { FC } from 'react';
import Create from 'components/fields/components/Create';

const Screen: FC = () => (
  <Create
    fieldsEntityName="fields"
    fieldsDropdownsEntityName="field-dropdowns"
    fieldsDropdownsEntityEndpoint="fields/dropdown-options"
  />
);

export default Screen;
